import React from 'react';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { useStyles } from './style';

/**
 * @name ActionModalBodyDescription - Action Modal Body
 * @param {object} props - CMS data from collection type Eir Action Modal
 * @returns {JSX.Element} - Body of the Action Modal
 */
const ActionModalBodyDescription = props => {
  const theme = useTheme();
  const style = useStyles(theme);

  return (
    <>
      {!props.load && props.description && (
        <Typography variant='body1' component='div' sx={style.textstyle}>
          {typeof props.description !== 'object' ? (
            <span
              dangerouslySetInnerHTML={{
                __html: props.description,
              }}
            />
          ) : (
            <span> {props.description} </span>
          )}
        </Typography>
      )}
    </>
  );
};

ActionModalBodyDescription.displayName = 'ActionModalBodyDescription';
export default ActionModalBodyDescription;
